import { render, staticRenderFns } from "./EvalMyEvaluations.vue?vue&type=template&id=f3520f22&scoped=true"
import script from "./EvalMyEvaluations.vue?vue&type=script&lang=js"
export * from "./EvalMyEvaluations.vue?vue&type=script&lang=js"
import style0 from "./EvalMyEvaluations.vue?vue&type=style&index=0&id=f3520f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3520f22",
  null
  
)

export default component.exports